import { render, staticRenderFns } from "./select-quarternary.vue?vue&type=template&id=6e975533&scoped=true&"
import script from "./select-quarternary.vue?vue&type=script&lang=js&"
export * from "./select-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e975533",
  null
  
)

export default component.exports